import { useRedirect } from '..';
import { scrollToTop } from '../transitions';

const sectionRegex =
    /[A-z-]*\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/;

const useLpRedirect = (): ((link: string) => void) => {
    const redirect = useRedirect();
    return (link: string) => {
        const isSectionLink = Boolean(link.match(sectionRegex));
        return redirect(link, undefined, !isSectionLink);
    };
};

const onLpRedirect = (link: string): void => {
    const isSectionLink = Boolean(link.match(sectionRegex));
    if (!isSectionLink) setTimeout(scrollToTop);
};

export { useLpRedirect, onLpRedirect };
